import { createContextualizedToken } from './createContextualizedToken';

// -- Link tokens --

export const [
  setContextualizedLinkColorText,
  proxyContextualizedLinkColorText,
] = createContextualizedToken({
  componentName: 'link',
  type: 'color',
  usage: 'text',
});

export const [
  setContextualizedLinkColorTextHovered,
  proxyContextualizedLinkColorTextHovered,
] = createContextualizedToken({
  componentName: 'link',
  type: 'color',
  usage: 'text',
  interaction: 'hovered',
});

export const [
  setContextualizedLinkColorTextPressed,
  proxyContextualizedLinkColorTextPressed,
] = createContextualizedToken({
  componentName: 'link',
  type: 'color',
  usage: 'text',
  interaction: 'pressed',
});

// -- Progress tokens --
export const [
  setContextualizedProgressCircleFillStroke,
  proxyContextualizedProgressCircleFillStroke,
] = createContextualizedToken({
  componentName: 'progress',
  type: 'color',
  usage: 'stroke',
  strokeType: 'fill',
});

export const [
  setContextualizedProgressCircleFullStroke,
  proxyContextualizedProgressCircleFullStroke,
] = createContextualizedToken({
  componentName: 'progress',
  type: 'color',
  usage: 'stroke',
  strokeType: 'full',
});

// -- SpotIllustration tokens --
export const [
  setContextualizedSpotIllustrationBackgroundColor,
  proxyContextualizedSpotIllustrationBackgroundColor,
] = createContextualizedToken({
  componentName: 'spot-illustration',
  type: 'color',
  usage: 'background',
});

export const [
  setContextualizedSpotIllustrationColor,
  proxyContextualizedSpotIllustrationColor,
] = createContextualizedToken({
  componentName: 'spot-illustration',
  type: 'color',
  usage: 'text',
});
